import React, { useEffect, useRef, useState } from 'react';

interface LazyComponentWrapperProps {
  rootMargin?: string;
  threshold?: number[];
}

/**
 * Component wrapper for lazy injection with IntersectionObserver
 * Thank you ChatGPT !
 */
const LazyComponentWrapper: React.FC<
  React.PropsWithChildren<LazyComponentWrapperProps>
> = ({ children, rootMargin = '100px', threshold = [0.1] }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect(); // Stop observing once visible
          }
        });
      },
      {
        rootMargin,
        threshold,
      }
    );

    observer.observe(ref.current);

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [rootMargin, threshold]);

  return <div ref={ref}>{isVisible ? children : null}</div>;
};

export default LazyComponentWrapper;
